import { MRT_ColumnDef, MRT_RowData } from "material-react-table";
import {
  CustomSearch,
  EstadoComponente,
} from "@/shared/components/ui";
import {
  useFetchSolicitudesEgreso,
} from "@/shared/actions/erp";
import {  useTableFilter } from "@/shared/hooks";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import {
  EstadosSolicitudPeodidoEnum,
} from "@/shared/interfaces";
import {  Grid, Typography } from "@mui/material";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useState} from "react";
import { SampleTable, SingleButton } from "@/shared/components/ui";
import { useMemo} from "react";


import VisibilityIcon from '@mui/icons-material/Visibility';
import { IUbicacionProducto } from "@/shared/interfaces/erp/inventario";
import { SolicitudesEgreso } from "@/shared/interfaces/erp/compras/solicitudes-egreso.interface";
type DetalleUsuarios ={
  id?: number;
  estado_solicitud?: string;
};

export default function SolicitudPedidosPrevAprobadosPagina() {
  const [isModalOpen, setIsModalOpen] = useState(false);
   const [details, setDetails] = useState<IUbicacionProducto[]>([]);
   const [numeroSolicutPedidos, setNumeroSolicitudesPedidos] = useState<string | null>(null);


  const columns = useMemo<MRT_ColumnDef<DetalleUsuarios>[]>(
    () => [
      {
        accessorKey: "detalles",
        header: "productos",
        size: 200,
        width: 200,
        Cell: ({ row }) => {
          return (
            <>
              <SingleButton
                label="ver"
                variant="text"
                color="info"
                onClick={() => {
                  onDetails(row.original);
                }}
                startIcon={<VisibilityIcon />}
              />
            </>
          );
        },
      },
      {
        accessorKey: "user.username",
        header: "usuario",
        size: 200,
        width: 200,
      },
      {
        accessorKey: "codigo",
        header: "No",
        size: 200,
        width: 200,
      },
      {
        accessorKey: "estado_solicitud",
        header: "estado",
        size: 200,
        Cell: ({ row }) => (
          row.original.estado_solicitud != null ?
            <EstadoComponente backgroundColor="green" texto={row.original.estado_solicitud || ''} /> : null
        ),
      },
      {
        accessorKey: "numero_referencia",
        header: "referencia",
        size: 200,
      },
      {
        accessorKey: "bodega",
        header: "bodega",
        size: 200,
      },
    ],
    []
  );

  const onDetails = (e: MRT_RowData) => {
    setDetails(JSON.parse(JSON.stringify(e.productos)));
    setIsModalOpen(true);
    setNumeroSolicitudesPedidos(e.numero_referencia);
  };
  const columnsProductosDetallePedidosDb: MRT_ColumnDef<IUbicacionProducto>[] =
  useMemo<MRT_ColumnDef<IUbicacionProducto>[]>(
    () => [
      {
        accessorKey: 'codigo',
        header: 'Código',
        Cell: ({ row }) => row.original?.codigo || 'N/A',
      },
      {
        accessorKey: 'descripcion',
        header: 'Descripción',
        Cell: ({ row }) => row.original?.producto_data?.descripcion || 'N/A',
      },

      {
        accessorKey: 'stock_actual',
        header: 'Stock Actual',
        // stock_actual = cantidad transferida
        Cell: ({ row }) => row.original?.producto_data?.stock_actual?? 'N/A',
      },
      {
        accessorKey: 'producto_data.modelo_producto',
        header: 'Modelo',
      },
      {
        accessorKey: 'producto_data.marca_producto',
        header: 'Marca',
      },
      {
        accessorKey: 'producto_data.categoria_producto',
        header: 'Categoria',
      },
      {
        accessorKey: 'producto_data.unidad_medida',
        header: 'Medida',
      },
    ],
    []
  );

  const {
    globalFilter,
    pagination,
    onChangeFilter,
    setPagination,
    //dateBefore,
    //dateAfter,
    onChangeRangeDate,
    cleanFilter
  } = useTableFilter();

  const { pageIndex } = pagination;

  const {
    data:solicitudPedidosAprobadossRes,
    isLoading: isLoadingSolicitudesPedidoPaging,
    isRefetching,
  } = useFetchSolicitudesEgreso({
    page_size: 600,
    page:pageIndex + 1,
    estado_solicitud: EstadosSolicitudPeodidoEnum.APROBADAS,
    //fecha_after: dateAfter,
    //fecha_before: dateBefore,
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
      <CustomSearch
          onChange={onChangeFilter}
          value={globalFilter}
          text=""
          onChangeRangeDate={onChangeRangeDate}
          cleanFilter={cleanFilter}
        />
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<SolicitudesEgreso>
          columns={columns}
          data={solicitudPedidosAprobadossRes?.data?.data || []}
          isLoading={isLoadingSolicitudesPedidoPaging}
          isRefetching={isRefetching}
          enableGlobalFilter={false}
          pagination={pagination}
          onPaging={setPagination}
          rowCount={solicitudPedidosAprobadossRes?.data?.count}
          actionsColumnSize={120}
          // crud
          enableColumnActions={false}
          enableEditing={false}
          canDelete={false}
          positionActionsColumn="first"
        />
      </Grid>
      <ScrollableDialogProps
        open={isModalOpen}
        title="Productos"
        cancelTextBtn="Cerrar"
        onClose={() => {
          setIsModalOpen(false);
         
        }}
        contentNode={
          <>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography variant="h6" gutterBottom style={{ textAlign: 'left', margin: '20px 0' }}>
        Número de Solicitud: {numeroSolicutPedidos}
      </Typography>
                {details.length > 0 && (
                  <SampleTable<IUbicacionProducto>
                    columns={columnsProductosDetallePedidosDb}
                    data={details}
                  />
                )}
              </Grid>
            </Grid>
          </>
        }
      />
    </Grid>
  );
}
